const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, {
  rootMargin: '0px 0px -100px 0px' // Trigger animation when image is 100px from entering viewport
});

document.querySelectorAll('.fade-in').forEach(img => {
  observer.observe(img);
});